import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type { SearchType } from '@beaded/shared-lib/src/searchTerms'

import * as apiUtils from '.'

const url = '/search'

export const get = (search: string, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({ params: { search } }, options))

export interface SearchPageParams {
  /** Only this type; absent returns the page of every type. */
  type?: SearchType
  limit: number
  offset?: number
}

/** One page per type (or of `type`), with `paging` totals. */
export const getPage = (
  search: string,
  page: SearchPageParams,
  options: AxiosRequestConfig = {},
) => apiUtils.GET(`${url}/`, merge({ params: { search, ...page } }, options))
